import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from "../../../SpecialtyPersonalStyles.module.scss"
import metadata from './ConstructionComponent.metadata.json5';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function ConstructionComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated, propertyDetailsPath, dwellingPathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('ConstructionComponent');

    const modelVM = _.get(submissionVM, pathUpdated);
    const proprtyModelVM = _.get(submissionVM, propertyDetailsPath);
    const dwellingVM = _.get(submissionVM, dwellingPathUpdated);
    const vacentOccCode = ['VacCom', 'VacDwe', 'VacCon']

    modelVM.value.isValidationReq = true;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        numofRooFie: {
            visible: !_.isUndefined(_.get(proprtyModelVM, 'occFie.value.code')) && _.get(proprtyModelVM, 'occFie.value.code') === 'RooHou'
                && !_.isUndefined(_.get(proprtyModelVM, 'doetheownlivonpreFie.value')) && _.get(proprtyModelVM, 'doetheownlivonpreFie.value')
        },
        buiTypOthdesFie: {
            visible:!_.isUndefined(_.get(modelVM, 'typofBuiFie.value.code')) && _.get(modelVM, 'typofBuiFie.value.code') === 'Other'
        },
        ifothpleexpFie: {
            visible: !_.isUndefined(_.get(modelVM, 'conFie.value.code')) && _.get(modelVM, 'conFie.value.code') === 'Other'
        },
        fouFie: {
            visible: !_.isUndefined(_.get(proprtyModelVM, 'occFie.value.code')) && !vacentOccCode.includes(_.get(proprtyModelVM, 'occFie.value.code'))
        },
        ifothple2exFie: {
            visible: !_.isUndefined(_.get(modelVM, 'rooRooTypFie.value.code')) && _.get(modelVM, 'rooRooTypFie.value.code') === 'Other'
        },
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            if (changedPath === 'yeaBuiFie' && modelVM.value.yeaBuiFie.length === 4) {
                if (modelVM.value.rooLasUpdFie === undefined) {
                    _.set(modelVM, 'rooLasUpdFie.value', value)
                }

                if (_.get(dwellingVM.value, 'utilities.yeaofInsFie') === undefined) {
                    _.set(dwellingVM, 'utilities.yeaofInsFie.value', value)
                }
    
                if (_.get(dwellingVM.value, 'utilities.yealasupdFie') === undefined) {
                    _.set(dwellingVM, 'utilities.yealasupdFie.value', value)
                }

                if (_.get(dwellingVM.value, 'utilities.eleSysYeaLasUpdFie') === undefined) {
                    _.set(dwellingVM, 'utilities.eleSysYeaLasUpdFie.value', value)
                }

                if (_.get(dwellingVM.value, 'utilities.pluLasUpdFie') === undefined) {
                    _.set(dwellingVM, 'utilities.pluLasUpdFie.value', value)
                }

                if (_.get(dwellingVM.value, 'solidFuelHeating.yeaofManFie') === undefined) {
                    _.set(dwellingVM, 'solidFuelHeating.yeaofManFie.value', value)
                }

                if (_.get(dwellingVM.value, 'utilities.yeaofIns2Fie') === undefined) {
                    _.set(dwellingVM, 'utilities.yeaofIns2Fie.value', value)
                }

                if (_.get(dwellingVM.value, 'utilities.yealasupd2Fie') === undefined) {
                    _.set(dwellingVM, 'utilities.yealasupd2Fie.value', value)
                }
            }

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ConstructionComponent.propTypes = wizardProps;
export default withRouter(ConstructionComponent);